import React, { Fragment } from 'react';
import { Button } from '@material-ui/core';
import { Link } from 'react-router-dom';
import striptags from 'striptags';

export const GeneralAlertDetail = (props) => {

  return (
    <Fragment>
      {content(props)}
    </Fragment>
  )
}

const createMarkup = (html) => {
  return {__html: html};
}

const buttons = (buttons) => {
  return buttons.map(({link, text}, i) => {
    if (
      link.indexOf('http') > -1 || 
      link.indexOf('https') > -1 ||
      link.indexOf('../../') > -1 ||
      link.indexOf('mailto') > -1
    ) {
      return (
        <Button
          key={i}
          style={{marginBottom: 10}}
          color='primary'
          variant='outlined'
          fullWidth
          onClick={() => {window.open(link)}}
        >
          {text}
        </Button>
      );
    } else if (
      link.indexOf('#/app/') > -1 ||
      link.indexOf('/') > -1
    ) {
      const routeArray = link.split('/');
      const route = link.indexOf('#/app/') > -1 ? routeArray[routeArray.length -1] : routeArray[0];
      return (
        <Button
          key={i}
          style={{marginBottom: 10}}
          color='primary'
          variant='outlined'
          fullWidth
          component={Link}
          to={route}
        >
          {text}
        </Button>
      );
    } else {
      return null;
    }
  })
}

const MarkUp = (props) => {
  return (
    <Fragment>
      {<div dangerouslySetInnerHTML={createMarkup(props.descriptionContent)} />}
      {buttons(props.buttons)}
    </Fragment>
  );
}

const content = (props) => {
  const anchor = striptags(props.description, ['a']);
  const div = document.createElement('div');
  const buttons = [];
  let strippedAlertButtonContent = props.description;
  div.innerHTML = anchor;
  
  const alertButtons = div.querySelectorAll('a.button');
  alertButtons.forEach(element => {
    buttons.push(
      {
        text: element.innerHTML ? element.innerHTML : 'View',
        link: element.href.replace(element.baseURI,'')
      }
    )
    strippedAlertButtonContent = strippedAlertButtonContent.replace(element.outerHTML, '');
  });
  return (
    <MarkUp
      descriptionContent={strippedAlertButtonContent}
      buttons={buttons}
    />
  );
}


// WEBPACK FOOTER //
// ./src/components/GeneralAlertDetail.js